import type { ReactNode } from "react";
import { useOptionalDocumentDrawer } from "../../../DocumentDrawer/DocumentDrawerProvider.tsx";
import { QuinnCopy } from "../../types";
import type { QuinnDocumentLinkTarget } from "../../utils";

export function QuinnDocumentLink({
    target,
    children,
}: {
    target: QuinnDocumentLinkTarget | null;
    children: ReactNode;
}) {
    const documentDrawer = useOptionalDocumentDrawer();
    if (!target || !documentDrawer) return <>{children}</>;

    return (
        <button
            type="button"
            onClick={() => documentDrawer.open(target.businessId, target.documentId)}
            title={QuinnCopy.OpenDocument}
            className="font-medium text-primary underline decoration-primary/30 underline-offset-2 transition-colors hover:decoration-primary"
        >
            {children}
        </button>
    );
}
